import React from "react";
import PropTypes from "prop-types";
import { Label } from "@cars24/turbo-web/lib/label";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import ArrowRight from "./images/arrow.svg";

const List = ({
    items
}) => {
    const { tokens } =  useTokens();

    return items.map((item, index) => {
        return (
            <ul styleName="styles.ulWrapper"
                key={`list${index}`}>
                <a href={item.url}>
                    <li styleName="styles.liWrapper">
                        <Label
                            level={3}
                            color={tokens.text_default_text_primary}
                            fontWeight={tokens.font_weight_medium}
                        >
                            {item.label}
                        </Label>
                        <img src={ArrowRight} alt="arrow"/>
                    </li>
                </a>
            </ul>
        );
    });

};

List.propTypes = {
    items: PropTypes.array
};

export default List;

